/**
 * Menu người dùng trên header — đăng nhập/đăng ký hoặc liên kết tài khoản đã auth.
 */
import { NavLink } from 'react-router-dom';
import { APP_ROUTES } from '../../shared/constants/routes';
import { TEXT } from '../../shared/languages';

const MENU_CLASS_NAMES = {
  panel: 'site-user-menu-panel',
  greeting: 'site-user-menu-greeting',
};

export const HeaderUserMenuPanel = ({
  isAuthenticated,
  user,
  canAccessAdmin,
  isLoggingOut,
  closeMenu,
  onLogout,
  onOpenRegister,
  onOpenLogin,
}) => {
  const nav = TEXT.nav;
  const classes = MENU_CLASS_NAMES;

  if (isAuthenticated) {
    return (
      <div className={classes.panel}>
        <p className={classes.greeting}>
          {nav.greeting}, {user?.name?.split(' ')[0] || nav.guest}
        </p>
        <NavLink to={APP_ROUTES.favorites} onClick={closeMenu}>
          {nav.favorites}
        </NavLink>
        <NavLink to={APP_ROUTES.profile} onClick={closeMenu}>
          {nav.profile}
        </NavLink>
        {canAccessAdmin && (
          <NavLink to={APP_ROUTES.admin} onClick={closeMenu}>
            {nav.admin}
          </NavLink>
        )}
        <button type="button" onClick={onLogout} disabled={isLoggingOut}>
          {isLoggingOut ? TEXT.auth.logoutSubmitting : nav.logout}
        </button>
      </div>
    );
  }

  return (
    <div className={classes.panel}>
      <button
        type="button"
        onClick={() => {
          closeMenu();
          onOpenRegister();
        }}
      >
        {nav.register}
      </button>
      <button
        type="button"
        onClick={() => {
          closeMenu();
          onOpenLogin();
        }}
      >
        {nav.login}
      </button>
    </div>
  );
};
